import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function Analytics() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-P9T1C23WRK', {
        page_path: location.pathname,
      });
    }
  }, [location]);

  return null;
}

export default Analytics;
